export const apiList = [
    {
        url: '/wiki/as/open/auth',
        type: 'get',
        returnCodeWhiteList: [
            '301',
            '200',
        ],
    },
    {
        url: /\/wiki\/as\/spaces\/([^\\/]+)\/groups\/([^\\/]+)\/repositories\/([^\\/]+)$/,
        type: 'get',
        returnCodeWhiteList: [
            '403',
            '401',
            '200',
            '404',
            '600',
        ],
    },
    {
        url: '/wiki/ku/space/groups/repositories/info',
        type: 'get',
        returnCodeWhiteList: [
            '403',
            '401',
            '200',
            '404',
            '600',
            '302',
            '301',
        ],
    },
    {
        url: /\/wiki\/ks\/([^\\/]+)\/docs\/([^\\/]+)$/,
        type: 'get',
        returnCodeWhiteList: [
            '403',
            '401',
            '200',
            '404',
            '301',
        ],
    },
    {
        url: '/wiki/ku/index/info/query',
        type: 'get',
        returnCodeWhiteList: [
            '301',
            '200',
            '403',
            '308',
        ],
    },
];

export const accessTokenUrl = '/wiki/ku/space/groups/repositories/accessTokens';

export const coreApiListForTime = [
    {
        url: '/wiki/as/open/check',
        type: 'get',
    },
    {
        url: '/wiki/as/open/auth',
        type: 'get',
    },
    {
        url: '/wiki/ku/space/groups/repositories/info',
        type: 'get',
    },
    {
        url: /\/wiki\/ks\/([^\\/]+)\/docs\/([^\\/]+)$/,
        type: 'get',
    },
    {
        url: accessTokenUrl,
        type: 'post',
    },
    {
        url: /\/wiki\/ks\/([^\\/]+)\/docs\/([^\\/]+)\/rteToken/,
        type: 'get',
    },
    {
        url: '/wiki/ku/index/info/query',
        type: 'get',
    },
];
